import { fontFamily } from './primitives/typography';

export const globalCss = {
  body: {
    colorPalette: 'brand',
    fontFamily: `'${fontFamily}', sans-serif`,
    textStyle: 'default.regular',
  },
  html: {
    fontFamily: `'${fontFamily}', sans-serif`,
  },
};
